<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
export default {
    name: 'artistList',
  
    data () {
        return {
            optionData : optionData,
            
            roleType : null,
            entity: '사업자개인',

            keywordOption :optionData.artistKeyword,
            keywordType :'display_name',
            keyword : '',
            total : 0,
            page: {
                pageSize : 50,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    this.viewDetail(event)
                },
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            columnDefs: [
                {headerName: '아티스트명', field: 'display_name', filter: false,minWidth: 250,
                cellRenderer: (data) => {
                    if(data.data.profile['thumbnail']){
                        return `<img class="artistTableImg" src="${data.data.profile['thumbnail']['remote_path']}"/>` + data.value
                    }else{
                        return `<img class="artistTableImg" src="${data.data.profile['remote_path']}"/>` + data.value
                    }
                }},
           
                {headerName: '연결앨범수',    field: 'album_count',   filter: false,width: 150},
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '국적',      field: 'nationality',     filter: false,width: 150, },
                {headerName: 'Licensor ID(Email)',    field: 'licensor.user.email',   filter: false,width: 250},
                {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 250,
                cellRenderer: (data) => {
                    let fm = data.data.licensor?.family_name ? data.data.licensor.family_name : '-';
                    let gm = data.data.licensor?.given_name ? data.data.licensor.given_name : '-' ;
                    return fm +' '+ gm
                }},
                {headerName: '회사명',    field: 'licensor.company',   filter: false,width: 250},

                {headerName: '화폐',  field: 'licensor.currency', filter: false,width: 125,
                cellRenderer: (data) => {
                    if(data.value){
                        return data.value.toUpperCase();
                    }else {
                        return ''
                    }
                    

                }},
                
                {headerName: '사업자여부',  field: 'licensor.entity', filter: false,width: 125,
                cellRenderer: (data) => {
                    let dd ={
                        'corporation': '사업자',
                        'individual' :'개인'
                    }
                    let text = ''
                    if(data.value == 'corporation'){
                        if(data.data.licensor.entity_tax_exemption == true){
                            text = dd[data.value] + '(면세)'    
                        }else{
                            text = dd[data.value] +'(비면세)'    
                        }
                    }else{
                        text = '-'
                    }
                    return text ;

                }}
            ],
            tableData:[
            ],       
            
            testMessage: "최고당!",

            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        
        callList(){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('LIST_ARTIST', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
        this.page.currentPage = 1  // 초기화
        this.callList()
        },
        viewDetail(event){
            this.$router.push('artist/detail/'+event.data.id)
        }
    }
}
</script>

<style scoped>

</style>
